module.exports = __webpack_public_path__ + "static/media/addHazardHover.7b2efa4e.png";